import React, { useEffect, useState } from 'react';
import Carousel from '../../ui/Carousel';
import AppStoreButton from '../../ui/AppStoreButton';
import { HERO_FEATURES } from '../../../utils/constants';
import { getAllScreenshots } from '../../../utils/helpers';
import styles from './HeroSection.module.css';

const HeroSection = () => {
  const [screenshots, setScreenshots] = useState([]);

  useEffect(() => {
    console.log('Loading screenshots...');
    
    // Use static list immediately - no dynamic detection, no waiting
    const staticScreenshots = getAllScreenshots();
    console.log('Static screenshots:', staticScreenshots);
    
    setScreenshots(staticScreenshots);

    // PROGRESSIVE LOADING FIX: Ensure full image download before display
    if (staticScreenshots.length > 0) {
      console.log('🔄 Preloading images to prevent progressive loading...');
      
      staticScreenshots.forEach((src, index) => {
        const img = new Image();
        
        // Force complete download before allowing display
        img.crossOrigin = 'anonymous'; // Helps with caching
        img.decoding = 'sync'; // Force synchronous decoding
        img.loading = 'eager'; // Load immediately
        
        img.onload = () => {
          console.log(`✅ Image ${index + 1} fully loaded and ready`);
          // Ensure image is completely rendered
          if (img.complete && img.naturalHeight > 0) {
            console.log(`📐 Image ${index + 1} dimensions: ${img.naturalWidth}x${img.naturalHeight}`);
          }
        };
        
        img.onerror = () => {
          console.warn(`❌ Image ${index + 1} failed to load: ${src}`);
        };
        
        // Start loading
        img.src = src;
      });
    }
  }, []);

  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.content}>
          {/* Left Column */}
          <div className={styles.textContent}>
            <h1 className={styles.title}>Subwise</h1>
            
            <div className={styles.features}>
              {HERO_FEATURES.map((feature, index) => (
                <div 
                  key={feature.id} 
                  className={styles.feature}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className={styles.featureBullet}></div>
                  <p className={styles.featureText}>{feature.text}</p>
                </div>
              ))}
            </div>
            
            <div className={styles.buttonWrapper}>
              <AppStoreButton />
            </div>
          </div>

          {/* Right Column - Show carousel immediately, no loading state */}
          <div className={styles.carouselWrapper}>
            {screenshots.length > 0 ? (
              <Carousel 
                images={screenshots}
                autoAdvance={true}
                showDots={true}
              />
            ) : (
              <div className="flex items-center justify-center w-full h-64">
                <div className="text-gray-500">No screenshots found</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;